import {Component, forwardRef, Injector, Input, OnChanges, SimpleChanges} from "@angular/core";
import {ColumnComponent} from "../../../framework/entity/grid/column.component";
import {
    AbstractSingleSelectColumnComponent
} from "../../../framework/entity/edit/edit-grid/columns/abstract-single-select-column.component";

@Component({
    selector: "wbo-course-single-select-column",
    templateUrl: "./course-single-select-column.component.html",
    providers: [
        {provide: ColumnComponent, useExisting: forwardRef(() => CourseSingleSelectColumnComponent), multi: true}
    ]
})
export class CourseSingleSelectColumnComponent extends AbstractSingleSelectColumnComponent implements OnChanges {
    @Input() courseDefinitionId: number;
    @Input() courseIdField: string;
    @Input() hideAddOption: boolean = false;

    constructor(injector: Injector) {
        super(injector);
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.valueField = this.courseIdField || (this.field + ".id");
        this.labelField = this.field + ".name";
    }

    override editingFields(): string[] {
        return [this.courseIdField, this.field];
    }
}
